export const TOUR_IDS = ["welcome", "session", "team", "developer"] as const;
export type TourId = (typeof TOUR_IDS)[number];

export type TourPlacement = "right" | "bottom" | "left" | "top";

export type TourStep = {
  /** Matches an element's `data-tour` attribute. */
  target: string;
  /** Navigate here before looking for the target (may carry a ?query). */
  route?: string;
  /** Keys under `tour.` in components/tour/_i18n. */
  titleKey: string;
  bodyKey: string;
  placement?: TourPlacement;
};

export type TourDef = {
  id: TourId;
  intro: { titleKey: string; bodyKey: string };
  steps: TourStep[];
  outroKey: string;
};
